export default __webpack_public_path__ + "static/physalis-c878e4c05ee9dfd75270ad76d63de4e2.png";